<div class="d-flex fd-col vh-100 overflow-y-auto custom-scrollbar" tabindex="0">
  <p class="d-flex mb-8 text-size-14 text-gray-3 pt-md-15 text-justify lh-150 p-1-em">
    Permite consultar el estado del tráfico en las calles y avenidas de la ciudad cada minuto, mostrando ubicación y su actividad en las últimas 3 horas. Haga clic en un punto sobre el mapa para consultar la información.
  </p>

  <div class="bg-color-background-1 d-flex">
    <div class="left-subtitle-block bg-color-primary-1"></div>
    <div class="d-flex full-width py-05">
      <sit-icon [icon]="Icon.speed" class="text-blue-1 ml-28" [sizeClass]="'icon-size-32'"></sit-icon>
      <h3 class="flex-grow text-weight-600 text-size-18 ml-16 text-md-size-18 text-color-secondary-2 align-self-center">
        VELOCIDAD
      </h3>
    </div>
  </div>

  <div class="d-flex">
    <div class="d-flex justify-space-around full-width py-container-speed">
      <div class="container-graphic-speed">
        <sit-speedometer [properties]="avgSpeedProps"></sit-speedometer>
      </div>
      <div class="container-graphic-speed">
        <sit-speedometer [properties]="avgConcordanceProps"></sit-speedometer>
      </div>
    </div>
  </div>

  <div class="bg-color-background-1 d-flex">
    <div class="left-subtitle-block bg-color-primary-1"></div>
    <div class="d-flex full-width py-05">
      <sit-icon [icon]="Icon.speed_range" class="text-blue-1 ml-28" [sizeClass]="'icon-size-32'"></sit-icon>
      <h3 class="flex-grow text-weight-600 text-size-18 ml-16 text-md-size-18 text-color-secondary-2 align-self-center">
        RANGO DE VELOCIDAD
      </h3>
    </div>
  </div>

  <div class="full-height full-width">
    <sit-chart-column [data]="listspeed" [id]="'speed-range'" className="h-350"></sit-chart-column>
  </div>

  <div class="bg-color-background-1 d-flex">
    <div class="left-subtitle-block bg-color-primary-1"></div>
    <div class="d-flex full-width py-05">
      <sit-icon [icon]="Icon.roads" class="text-blue-1 ml-28" [sizeClass]="'icon-size-32'"></sit-icon>
      <h3 class="flex-grow text-weight-600 text-size-18 ml-16 text-md-size-18 text-color-secondary-2 align-self-center">
        RUTAS PRINCIPALES
      </h3>
    </div>
  </div>

  <div class="table-title d-flex fd-row text-white text-weight-400 justify-space-around bg-color-secondary-4 py-10-px">
    <span>VELOCIDAD</span>
    <span>TIEMPO</span>
    <span>RANGO</span>
    <span>CONCORDANCIA</span>
  </div>

  <div class="list-cards" [scrollHandler]="panelActionsDispatcher">
    <ng-container *ngFor="let card of cards">
      <sit-card-traffic [card]="card"></sit-card-traffic>
    </ng-container>
  </div>
</div>
